import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
  ButtonGroup,
  DropdownButton,
  MenuItem,
  Label,
  Tabs,
  Tab,
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
//import Alert          from '../../../components/alert/Alert';
import { createBrowserHistory } from 'history';
import {
  NewBreadcrumb as BreadcrumbComponent
}                        from '../../../components';

// include action file for add merchant
import '../../../style/subAdmin/SubAdmin.scss';
import { Notification } from '../../../components/notifications';
import isEmpty from 'lodash.isempty';
import { emailOverview, deleteEmail, sendTestMail, emailStatus } from '../../../redux/actions/emailManagerActions';
import {renderAlert, clearAlert} from '../../../redux/actions/alertsActions';
import { getCities } from "../../../redux/actions/countryCityActions";
import DatePicker from 'react-date-picker';
 import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from 'moment';
import loader from '../../../style/loader/loader.scss'; 
import '../../../style/react-datetimepicker.scss';

import ReactHtmlParser from 'react-html-parser';
import Dialog from 'react-bootstrap-dialog';
import DateTimePicker from 'react-datetime-picker';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

import Pagination from 'react-paginating';
const history = createBrowserHistory();

const HorizontalLine = ({ }) => (
    <hr/>
);

const propTypes = {
    emailOverview: PropTypes.func.isRequired,
};
let cityItems=[];let isLoading="false",  csvData = [];
import {aclUtil} from "../../util";
class Overview extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props){

    super(props);
    this.state={
      path: ['Home', 'Email Manager'], 
      links: ["home",'email-manager/overview'],
      date: new Date(),
      citiesList: [],
      range: false,
      disabled: false,
      cityID: '',
      isLoading: 'false',
      emailList: '',
      emailType: '',
      popUpData: '',
      popUpStatus: false,
      popUpHtmlData: '',
      popUpHtmlStatus: false,
      emailPopUpData: '',
      emailPopUpStatus: false,
      email: '',
      alertMessage: '',
      show: false,
      campPopUpStatus: false,
      campData: '',
      campDataError: '',
      totalRecords: 0,
      perPage: 0,
      limit:25,
      currentPage: 1,
      pageCount:0,
      startDate: '',
      startDateRange: '',
      range: false,
      statuspopUpStatus: false,
      statusList: '',
      tabStatus: 'active',
      key: 1
    }

    this.validate=this.validate.bind(this);
    this.handleChange=this.handleChange.bind(this);
    this.handleSubmit=this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear=this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
    // this.handleExport = this.handleExport.bind(this);
    this.deleteCampaign = this.deleteCampaign.bind(this);

    this.openPopup = this.openPopup.bind(this);
    this.openHtmlPopup = this.openHtmlPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.closeHtmlPopup = this.closeHtmlPopup.bind(this);
    
    this.emailOpenPopup = this.emailOpenPopup.bind(this);
    this.emailClosePopup = this.emailClosePopup.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleEmailExecute = this.handleEmailExecute.bind(this);
    this.deleteSchedule = this.deleteSchedule.bind(this);

    this.campPopUpStatus = this.campPopUpStatus.bind(this);
    this.campClosePopup = this.campClosePopup.bind(this);
    this.handleCampaign = this.handleCampaign.bind(this);

  }

  onChangeCampDate = date => this.setState({ campData: date, campDataError: '' });

  campPopUpStatus = (e) => {
    this.setState({campPopUpStatus: true});
  }

  campClosePopup = (e) => {
    this.setState({campPopUpStatus: false, campData: ''});
  }

  handleCampaign = (e) => {
    if(!this.state.campData){
      this.setState({campDataError : "Please select date first."});
      return false;
    }
    sessionStorage.setItem('campData', this.state.campData);
    

    if(sessionStorage.getItem('campData')){
      this.context.router.history.push('/email-manager/multiofferemail');
    }
  }

  handleEmailChange = (e) => {
    this.setState({email: e.target.value, emailError:""});
  }

  handleEmailExecute = (e) => {
    if(this.state.email.length === 0){    
      this.setState({emailError:"red"});
      return false;
    }
    let constData = {
      id : this.state.emailPopUpData,
      email :  this.state.email,
    }

    isLoading="true";
    this.props.sendTestMail(constData);
  }

  // onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDate = (selectedDate) => {
   
    if (selectedDate instanceof Date && !isNaN(selectedDate)) {
         this.setState({
          startDate: selectedDate,
         
         });
       } 
       else if(selectedDate  === null)
       {
        this.setState({
          startDate: '',
      
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
       
    
       }
     };
  // onChangeStartDateRange = date => this.setState({ startDateRange: date});
  onChangeStartDateRange = date => {
    
   
    if (date && date[0] instanceof Date && !isNaN(date[0])) {

         this.setState({
          startDateRange: date,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(date  === null)
       {
        this.setState({
          startDateRange: '',
        
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
         this.setState({
      
   
           
         });
    
       }
     };

  changeDatePicker = status => {
    if(this.state.range == false){
      this.setState({range: true})
    }else{
      this.setState({range: false})
    }
  }
  deleteSchedule = (e) => {
    let id = e.target.attributes.getNamedItem('data-key').value;
    this.dialog.show({
      body: 'Are you sure you want to delete this?',
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.deleteCampaign(id);
        })
      ]
    })
  }

  deleteCampaign = (id) => {
    
    isLoading = "true";
    this.props.deleteEmail(id);
  }

  emailOpenPopup = (e) => {

    let data = e.target.attributes.getNamedItem('data-key').value;
    this.setState({
      emailPopUpData: data,
      emailPopUpStatus: true,
    });
  }

  emailClosePopup = (e) => {
    this.setState({
      emailPopUpData: '',
      emailPopUpStatus: false,
      email: '',
    })
  }

  openPopup = (e) => {
    let data = (e.target.attributes.getNamedItem('data-key').value) - 1;
    let emailList = this.state.emailList.data;
    this.setState({
      popUpData: emailList[data].email_content,
      popUpStatus: true,
    })
  }

  openHtmlPopup = (e) => {
    let data = (e.target.attributes.getNamedItem('data-key').value) - 1;
    let emailList = this.state.emailList.data;
    this.setState({
      popUpHtmlData: emailList[data].email_content,
      popUpHtmlStatus: true,
    })
  }

  closePopup = (e) => {
    this.setState({
      popUpData: '',
      popUpStatus: false,
    })
  }

  closeHtmlPopup = (e) => {
    this.setState({
      popUpHtmlData: '',
      popUpHtmlStatus: false,
    })
  }

  openStatusPopup = (e) => {
    let data = e.target.attributes.getNamedItem('data-key').value;
    isLoading = "true";
    this.props.emailStatus({id: data});
  }

  closeStatusPopup = (e) => {
    this.setState({
      statuspopUpStatus: false,
      statusList: '',
    })
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e){
    this.setState({[e.target.name]:e.target.value}) 
  }

  validate = () => { 
    let isError = false;
    const errors = {};
  
    return isError;

  }

  handleSubmit(e){
    e.preventDefault();
    isLoading="true";
    let constData = {
      search: this.state.emailType,
      cityId: this.state.cityId,
      page:1,
      type : (this.state.key == '1') ? 'active' : 'sent',
    }

    if(this.state.range == true){
      let dateRange = this.state.startDateRange;
      constData.startdate = (dateRange[0]) ? moment(dateRange[0]).format('YYYY-MM-DD') : '';
      constData.enddate = (dateRange[1]) ? moment(dateRange[1]).format('YYYY-MM-DD') : '';
    }else{
      constData.startdate = (this.state.startDate) ? moment(this.state.startDate).format('YYYY-MM-DD') : '';
    }
    this.props.emailOverview(constData);
  }

  Clear = () => {
    
  }


  handlePageChange = page => {
    isLoading="true";
    this.setState({
      currentPage: page
    });

    let constData = {
      type: this.state.tabStatus,
      search: this.state.emailType,
      cityId: this.state.cityId,
      page:page,
      limit: this.state.limit
    }
    if(this.state.range == true){
      let dateRange = this.state.startDateRange;
      constData.startdate = dateRange[0];
      constData.enddate = dateRange[1];
    }else{
      constData.startdate = this.state.startDate;
    }

    this.props.emailOverview(constData);
  };


  componentWillMount(){
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getCities();
    this.handlePageChange();

  }

  componentWillReceiveProps(nextProps){
     
      if(this.props.error !== nextProps.error){
        if(nextProps.error){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('warning',nextProps.error);
          isLoading="false";
        }
      } 

      this.setState({ sending: nextProps.sending });

      if (this.props.activecities !== nextProps.activecities && nextProps.activecities) {
        this.setState({ citiesList: nextProps.activecities });
      }

      if(this.props.testMailStatus !== nextProps.testMailStatus){
        if(nextProps.testMailStatus){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('success', nextProps.testMailStatus.message);
          this.emailClosePopup();
          isLoading="false";
          window.scrollTo(0, 0);
        }
      }

      if(this.props.deleteStatus !== nextProps.deleteStatus){
        if(nextProps.deleteStatus){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('success', nextProps.deleteStatus.message);
          isLoading="false";
          window.scrollTo(0, 0);
        }
      }

      if(this.props.emailList !== nextProps.emailList){
        if(nextProps.emailList){
          isLoading="false";
          const setPageCount = nextProps.emailList.data.total / nextProps.emailList.data.per_page;
          this.setState({emailList: nextProps.emailList.data, totalRecords:nextProps.emailList.data.total, perPage:nextProps.emailList.data.per_page, pageCount:5})
        }
      }

      if(this.props.status !== nextProps.status){
        if(nextProps.status){
          isLoading="false";
          this.setState({statusList: nextProps.status.data, statuspopUpStatus: true});
        }
      }

      if(nextProps.message){
        this.handleShow();
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
      }

      if(this.props.deleteStatus !== nextProps.deleteStatus){
        if(nextProps.deleteStatus){
          this.handlePageChange();
        }
      }

      if(this.props.cityList != nextProps.cityList){
        if(nextProps.cityList){
          this.setState({cityList: nextProps.cityList.data});
        }
      }

     
  }

  handleCampaignStatus = (key) => {
    if(key === 1){
      this.setState({tabStatus : 'active', emailList: '', totalRecords:'', perPage:'', pageCount:'', key: key});
      isLoading="true";

      let constData = {
        type: 'active',
        search: this.state.emailType,
        cityId: this.state.cityId,
        page:this.state.currentPage,
        limit: this.state.limit
      }
      if(this.state.range == true){
        let dateRange = this.state.startDateRange;
        constData.startdate = dateRange[0];
        constData.enddate = dateRange[1];
      }else{
        constData.startdate = this.state.startDate;
      }

      this.props.emailOverview(constData);
    }else if(key === 2){
      this.setState({tabStatus : 'sent', emailList: '', totalRecords:'', perPage:'', pageCount:'', key: key});
      isLoading="true";

      let constData = {
        type: 'sent',
        search: this.state.emailType,
        cityId: this.state.cityId,
        page:this.state.currentPage,
        limit: this.state.limit
      }
      if(this.state.range == true){
        let dateRange = this.state.startDateRange;
        constData.startdate = dateRange[0];
        constData.enddate = dateRange[1];
      }else{
        constData.startdate = this.state.startDate;
      }

      this.props.emailOverview(constData);
    }else{
      this.setState({tabStatus : 'active', emailList: '', totalRecords:'', perPage:'', pageCount:''});
      isLoading="true";

      let constData = {
        type: 'active',
        search: this.state.emailType,
        cityId: this.state.cityId,
        page:this.state.currentPage,
        limit: this.state.limit
      }
      if(this.state.range == true){
        let dateRange = this.state.startDateRange;
        constData.startdate = dateRange[0];
        constData.enddate = dateRange[1];
      }else{
        constData.startdate = this.state.startDate;
      }

      this.props.emailOverview(constData);
    }
  }

  render() {
    const { currentPage,totalRecords,perPage,pageCount } = this.state
    const offertooltip = (
      <Tooltip id="offertooltip">
        <strong>Send offers and contest emails to targeted customer list.</strong>
      </Tooltip>
    );

    const customtooltip = (
      <Tooltip id="customtooltip">
        <strong>Send any custom email to targeted customer list.</strong>
      </Tooltip>
    );

    const multiofferooltip = (
      <Tooltip id="multiofferooltip">
        <strong>Send an email with many offers.</strong>
      </Tooltip>
    );
    
    return (
      <div className="col-lg-12 add-sub-admin">
        <Dialog ref={(el) => { this.dialog = el }} />
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
       
        <div className="row">
          <div className="col-xs-12">
             <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
        <div className="panel">
          <header className="panel-heading">Email Manager Overview
            <span className="pull-right">
              {aclUtil.checkACL('ADD_COMPAIGN') ? (<OverlayTrigger placement="bottom" overlay={offertooltip}>
                <Button bsSize="small" bsStyle="success" onClick={() => this.context.router.history.push('/email-manager/offeremail')}>+ Offer Email</Button>
              </OverlayTrigger>) :("")}
              {aclUtil.checkACL('ADD_COMPAIGN') ? (<OverlayTrigger placement="bottom" overlay={customtooltip}>
                <Button bsSize="small" bsStyle="success" onClick={() => this.context.router.history.push('/email-manager/customemail')}>+ Custom Email</Button>
              </OverlayTrigger>) :("")}
              {aclUtil.checkACL('ADD_COMPAIGN') ? (<OverlayTrigger placement="bottom" overlay={multiofferooltip}>
                <Button bsSize="small" bsStyle="success" onClick={this.campPopUpStatus}>+ Multi Offer Email</Button>
              </OverlayTrigger>) :("")}
            </span>
          </header>
          <div className="panel-body">
            <Row>
              <Col md={4} xs={12}>
                  <FormGroup controlId="currency">
                    <ControlLabel>Filter By</ControlLabel>
                    <FormControl componentClass="select" style={{borderColor:this.state.filter}} onChange={this.handleChange} name="emailType" value={this.state.filter}>
                      <option value="">Select Campaign Name</option>
                      <option value="customEmail">Custom Email</option>
                      <option value="offerContest">Offer</option>
                      <option value="multiOffer">Multi Offer Email</option>
                    </FormControl>
                    {/* <p className="inline-validation-error">{this.state.contractTypeError !== '' ? this.state.contractTypeError : ' '}</p> */}
                  </FormGroup>
              </Col>
              <Col md={4} xs={12}>
                <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {(this.state.range == false) ?
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    :
                   
                    (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                   )
                    }
                  </FormGroup>
              </Col>
              <Col md={4} xs={12}>
                <FormGroup controlId="cityFilter">
                  <ControlLabel>City</ControlLabel>
                  <FormControl componentClass="select" style={{borderColor:this.state.filter}} onChange={this.handleChange} name="cityId" value={this.state.filter}>
                    <option value="">Select City</option>
                    {this.state.citiesList.map((data, index) => 
                      <option key={index} value={data.cityID}>{data.title}</option>
                      )}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12} xs={12}>
                
                <Button bsStyle="info" type="submit" id="saveButton" disabled={this.state.disabled}>Submit</Button>
                {(this.state.range == false) ?
                  <a className="btn btn-success" type="submit" onClick={this.changeDatePicker} id="saveButton">Use Range</a>
                :
                  <a className="btn btn-success" type="submit" onClick={this.changeDatePicker} id="saveButton">Use Date</a>
                }
              </Col>
            </Row>
            
          </div>
        </div> 
        </form>
        {/**end contract information **/}

        <div className="panel">
          {this.state.show && this.state.alertMessage !=='' &&        
            <div className="col-lg-12">
              <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
              <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
            </Alert>
            </div>
          }
          <div className="panel-body">
            <Tabs activeKey={this.state.key} onSelect={this.handleCampaignStatus} id="controlled-tab-example">                      
              <Tab eventKey={1} title="Pending Campaigns">
                <table className="table table-hover table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Campaign Name</th>
                      <th>Merchant Name</th>
                      <th>City</th>
                      <th>Campaign Type</th>
                      <th>Target</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                      {(!isEmpty(this.state.emailList.data)) ? 
                        this.state.emailList.data.map((data, index) => 
                          <tr key={index}>
                            <td>{++index}</td>
                            <td>{data.campaignName}</td>
                            <td>{data.merchantname}</td>
                            <td>{data.campaigncity}</td>
                            <td> 
                              {(data.emailType == 'customEmail') ? 'Custom Email' : ''}
                              {(data.emailType == 'offerContest') ? 'Offer Email' : ''}
                              {(data.emailType == 'multiOffer') ? 'Multi Offer Email' : ''}
                            </td>
                            <td width="14%">User : {(data.target_users) ? data.target_users : 0} <br/> Subscribers : {(data.target_subscribers) ? data.target_subscribers : 0} <br/> CSV : {(data.target_csv) ? data.target_csv : 0} <br/> Imported files : {(data.sheet_used) ? data.sheet_used : 0} <br/> Read : {(data.read_by) ? data.read_by : 0}</td>
                            <td>
                              {data.status == 'active' ? <Label bsStyle="success"> Pending</Label> : (data.status == 'in_progress') ? <Label bsStyle="success">In Progress</Label> : ''}
                              <br/>
                              Schedule On : {moment(data.scheduleOn).format("ll hh:mm A")}
                            </td>
                            <td>
                              <ButtonGroup>
                                <DropdownButton title="Action" id="bg-nested-dropdown">
                                  <MenuItem eventKey={Math.random()}  data-key={data.emailManagerID} onClick={this.emailOpenPopup}><i className="glyphicon glyphicon-send"></i> Test Email</MenuItem>
                                  {(data.emailType == 'customEmail') &&
                                  <MenuItem eventKey={Math.random()}  onClick={() => this.context.router.history.push(`/email-manager/customemail/${data.emailManagerID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit Email HTML</MenuItem>
                                  }

                                  {(data.emailType == 'offerContest') &&
                                  <MenuItem eventKey={Math.random()}  onClick={() => this.context.router.history.push(`/email-manager/create-offer-email/${data.dealID}/${data.emailManagerID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit Email HTML</MenuItem>
                                  }

                                  {(data.emailType == 'multiOffer') &&
                                  <MenuItem eventKey={Math.random()}  onClick={() => this.context.router.history.push(`/email-manager/multiofferemail/${data.emailManagerID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit Email HTML</MenuItem>
                                  }
                                  <MenuItem eventKey={Math.random()} data-key={data.emailManagerID} onClick={this.deleteSchedule}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>
                                  {(data.second_street == 0) &&
                                  <MenuItem eventKey={Math.random()} data-key={data.emailManagerID} onClick={this.openStatusPopup}><i className="glyphicon glyphicon-eye-open"></i> Status</MenuItem>
                                  }
                                  <MenuItem eventKey={Math.random()} data-key={index} onClick={this.openPopup}><i className="glyphicon glyphicon-eye-open"></i> Preview</MenuItem>
                                  <MenuItem eventKey={Math.random()} data-key={index} onClick={this.openHtmlPopup}><i className="glyphicon glyphicon-eye-open"></i> Email HTML</MenuItem>
                                </DropdownButton>
                            </ButtonGroup>
                            </td>
                          </tr>
                        )
                      :
                      <tr><td colSpan="6" className="text-center">Data Not Found</td></tr>
                      }
                  </tbody>
                </table>
                <div className="text-center">
                      <Pagination
                        total={totalRecords}
                        limit={perPage}
                        pageCount={5}
                        currentPage={currentPage}
                      >
                        {({
                          pages,
                          currentPage,
                          hasNextPage,
                          hasPreviousPage,
                          previousPage,
                          nextPage,
                          totalPages,
                          getPageItemProps
                        }) => (
                          <div className="pagination">
                            <button
                              {...getPageItemProps({
                                pageValue: 1,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              first
                            </button>

                            {hasPreviousPage && (
                              <button
                                {...getPageItemProps({
                                  pageValue: previousPage,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {'<'}
                              </button>
                            )}

                            {pages.map(page => {
                              let activePage = null;
                              if (currentPage === page) {
                                activePage = { backgroundColor: '#ccc', color: '#666' };
                              }
                              return (
                                <button
                                  key={page}
                                  style={activePage}
                                  {...getPageItemProps({
                                    pageValue: page,
                                    onPageChange: this.handlePageChange
                                  })}
                                >
                                  {page}
                                </button>
                              );
                            })}

                            {hasNextPage && (
                              <button
                                {...getPageItemProps({
                                  pageValue: nextPage,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {'>'}
                              </button>
                            )}

                            <button
                              {...getPageItemProps({
                                pageValue: totalPages,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              last
                            </button>
                          </div>
                        )}
                      </Pagination>
                </div>
              </Tab>
              <Tab eventKey={2} title="Sent Campaigns">
                <table className="table table-hover table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Campaign Name</th>
                      <th>Merchant Name</th>
                      <th>City</th>
                      <th>Campaign Type</th>
                      <th>Target</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                      {(!isEmpty(this.state.emailList.data)) ? 
                        this.state.emailList.data.map((data, index) => 
                          <tr key={index}>
                            <td>{++index}</td>
                            <td>{data.campaignName}</td>
                            <td>{data.merchantname}</td>
                            <td>{data.campaigncity}</td>
                            <td> 
                              {(data.emailType == 'customEmail') ? 'Custom Email' : ''}
                              {(data.emailType == 'offerContest') ? 'Offer Email' : ''}
                              {(data.emailType == 'multiOffer') ? 'Multi Offer Email' : ''}
                            </td>
                            <td width="14%">User : {(data.target_users) ? data.target_users : 0} <br/> Subscribers : {(data.target_subscribers) ? data.target_subscribers : 0} <br/> CSV : {(data.target_csv) ? data.target_csv : 0} <br/> Imported files : {(data.sheet_used) ? data.sheet_used : 0} <br/> Read : {(data.read_by) ? data.read_by : 0}</td>
                            <td>
                              {data.status == 'active' ? <Label bsStyle="success"> Pending</Label> : (data.status == 'in_progress') ? <Label bsStyle="success">In Progress</Label> : ''}
                              <br/>
                              Schedule On : {moment(data.scheduleOn).format("ll hh:mm A")}
                            </td>
                            <td>
                              <ButtonGroup>
                                <DropdownButton title="Action" id="bg-nested-dropdown">
                                  <MenuItem eventKey={Math.random()}  data-key={data.emailManagerID} onClick={this.emailOpenPopup}><i className="glyphicon glyphicon-send"></i> Test Email</MenuItem>
                                  {(data.emailType == 'customEmail') &&
                                  <MenuItem eventKey={Math.random()}  onClick={() => this.context.router.history.push(`/email-manager/customemail/${data.emailManagerID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit Email HTML</MenuItem>
                                  }

                                  {(data.emailType == 'offerContest') &&
                                  <MenuItem eventKey={Math.random()}  onClick={() => this.context.router.history.push(`/email-manager/create-offer-email/${data.dealID}/${data.emailManagerID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit Email HTML</MenuItem>
                                  }

                                  {(data.emailType == 'multiOffer') &&
                                  <MenuItem eventKey={Math.random()}  onClick={() => this.context.router.history.push(`/email-manager/multiofferemail/${data.emailManagerID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit Email HTML</MenuItem>
                                  }

                                  <MenuItem eventKey={Math.random()} data-key={data.emailManagerID} onClick={this.deleteSchedule}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>

                                  {(data.second_street == 0) &&
                                  <MenuItem eventKey={Math.random()} data-key={data.emailManagerID} onClick={this.openStatusPopup}><i className="glyphicon glyphicon-eye-open"></i> Status</MenuItem>
                                  }
                                  <MenuItem eventKey={Math.random()} data-key={index} onClick={this.openPopup}><i className="glyphicon glyphicon-eye-open"></i> Preview</MenuItem>
                                  <MenuItem eventKey={Math.random()} data-key={index} onClick={this.openHtmlPopup}><i className="glyphicon glyphicon-eye-open"></i> Email HTML</MenuItem>
                                </DropdownButton>
                            </ButtonGroup>
                            </td>
                          </tr>
                        )
                      :
                      <tr><td colSpan="6" className="text-center">Data Not Found</td></tr>
                      }
                  </tbody>
                </table>
                <div className="text-center">
                      <Pagination
                        total={totalRecords}
                        limit={perPage}
                        pageCount={5}
                        currentPage={currentPage}
                      >
                        {({
                          pages,
                          currentPage,
                          hasNextPage,
                          hasPreviousPage,
                          previousPage,
                          nextPage,
                          totalPages,
                          getPageItemProps
                        }) => (
                          <div className="pagination">
                            <button
                              {...getPageItemProps({
                                pageValue: 1,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              first
                            </button>

                            {hasPreviousPage && (
                              <button
                                {...getPageItemProps({
                                  pageValue: previousPage,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {'<'}
                              </button>
                            )}

                            {pages.map(page => {
                              let activePage = null;
                              if (currentPage === page) {
                                activePage = { backgroundColor: '#ccc', color: '#666' };
                              }
                              return (
                                <button
                                  key={page}
                                  style={activePage}
                                  {...getPageItemProps({
                                    pageValue: page,
                                    onPageChange: this.handlePageChange
                                  })}
                                >
                                  {page}
                                </button>
                              );
                            })}

                            {hasNextPage && (
                              <button
                                {...getPageItemProps({
                                  pageValue: nextPage,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {'>'}
                              </button>
                            )}

                            <button
                              {...getPageItemProps({
                                pageValue: totalPages,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              last
                            </button>
                          </div>
                        )}
                      </Pagination>
                </div>
              </Tab>
            </Tabs>
            </div>
        </div>


        {/*<Modal show={this.state.popUpStatus} onHide={this.closePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Email Template Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {ReactHtmlParser(this.state.popUpData)}
          </Modal.Body>
          <Modal.Footer>
           { <Button bsStyle="success" onClick={this.handleExecute.bind(this)}>Execute</Button>}
            <Button bsStyle="danger" onClick={this.closePopup}>Close</Button>
          </Modal.Footer>
        </Modal>
        //-------------Commented by visham
        */} 

        <Modal show={this.state.emailPopUpStatus} onHide={this.emailClosePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Send Test Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <FormGroup>
                  <ControlLabel>Enter an email address below to send a test email. Useful if you want to preview what the email will look like in your customers inbox.</ControlLabel>
                  <FormControl
                    type="email"
                    value={this.state.email}
                    placeholder="Enter Email"
                    onChange={this.handleEmailChange}
                    style={{borderColor:this.state.emailError}}
                  />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleEmailExecute}>Send Mail</Button>
            <Button bsStyle="danger" onClick={this.emailClosePopup}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.popUpStatus} onHide={this.closePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Email Template Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {ReactHtmlParser(this.state.popUpData)} {/*ReactHtmlParser(this.state.popUpData)        Replace by visham*/}
          </Modal.Body>
          <Modal.Footer>
           {/* <Button bsStyle="success" onClick={this.handleExecute.bind(this)}>Execute</Button>*/}
            <Button bsStyle="danger" onClick={this.closePopup}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.popUpHtmlStatus} onHide={this.closeHtmlPopup}>
          <Modal.Header closeButton>
            <Modal.Title>Email HTML</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.popUpHtmlData} {/*Add by visham*/}
          </Modal.Body>
          <Modal.Footer>
           {/* <Button bsStyle="success" onClick={this.handleExecute.bind(this)}>Execute</Button>*/}
            <Button bsStyle="danger" onClick={this.closeHtmlPopup}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.campPopUpStatus} onHide={this.campClosePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Campaign</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <FormGroup>
                  <ControlLabel>Select Campaign Date</ControlLabel><br/>
                  <DateTimePicker
                    onChange={this.onChangeCampDate}
                    value={this.state.campData}
                    minDate={new Date()}
                  /><br/>
                  {(this.state.campDataError) &&
                    <span className="text-danger">{this.state.campDataError}</span>
                  }
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleCampaign}>Make Campaign</Button>
            <Button bsStyle="danger" onClick={this.campClosePopup}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.statuspopUpStatus} onHide={this.closeStatusPopup}>
          <Modal.Header closeButton>
            <Modal.Title>Campaign</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <table className="table table-hover table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Email Address</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
                {(!isEmpty(this.state.statusList)) ? 
                  this.state.statusList.map((data, index) => 
                  <tr key={data.email}>
                    <td>{++index}</td>
                    <td>{data.email}</td>
                    <td className={(data.status == 'progress') ? 'text-danger' : 'text-success'}>{(data.status == 'progress') ? 'In Progress' : 'Read'}</td>
                  </tr> 
                  )
                :
                <tr><td colSpan="6" className="text-center">Data Not Found</td></tr>
                }
            </tbody>
          </table>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.closeStatusPopup}>Close</Button>
          </Modal.Footer>
        </Modal>
        
       
       {/*<Row className="BtnRow">
                 <Col md={12} xs={12}>
                   <Button bsStyle="info" type="submit" id="saveButton" disabled={this.state.disabled}>Save</Button>
                   <Button bsStyle="default" onClick={() => this.context.router.history.push(`/contractList`)}>Cancel</Button>
                 </Col>
               </Row>*/}
       
      </div>
    );
  }
}
 
 

const mapStateToProps = (state,ownProps) => {
    return {
      activecities: state.countryCityReducers.activecities,
      sending:  state.emailManagerReducer.sending,
      error: state.emailManagerReducer.error,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
      emailList:  state.emailManagerReducer.emailList,
      deleteStatus: state.emailManagerReducer.deleteStatus,
      testMailStatus: state.emailManagerReducer.testMailStatus,
      status: state.emailManagerReducer.status,
    };
};

export default compose(
  withRouter, 
  connect(mapStateToProps, {renderAlert, clearAlert, emailOverview, deleteEmail, sendTestMail, getCities, emailStatus})
)(Overview);



// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/Overview.js